import { getShortAgents } from '../../api';
import { useAppContext, useFetch } from '../../hooks';

export const useCallAgents = () => {
  const {
    meta: { conferenceAgentsTenantId },
  } = useAppContext();

  const { intializing, data } = useFetch(() => {
    if (!conferenceAgentsTenantId) return [];

    return getShortAgents(conferenceAgentsTenantId);
  }, [conferenceAgentsTenantId]);

  return { loading: intializing, agents: data || [] };
};
